import { render, staticRenderFns } from "./ContributionsWidget.vue?vue&type=template&id=40aa7b58&scoped=true"
import script from "./ContributionsWidget.vue?vue&type=script&lang=ts"
export * from "./ContributionsWidget.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsWidget.vue?vue&type=style&index=0&id=40aa7b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa7b58",
  null
  
)

export default component.exports